import React from "react";
import { Close } from "@mui/icons-material";
import classNames from "classnames";
import { makeStyles } from "@mui/styles";
import theme from "theme";

const useStyles = makeStyles((theme) => ({
  root: {
    maxHeight: 20,
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: theme.palette.primary.main,
    borderRadius: "16px",
    padding: "4px 8px",
    fontSize: "14px",
    color: theme.palette.common.white,
    cursor: "default",
    border: "1px solid #ccc",
    whiteSpace: "nowrap",
  },
  closeIcon: {
    cursor: "pointer",
    color: "#666",
    borderRadius: "50%",
    transition: "background 0.2s",
  },
}));

const CustomChip = ({ label, onDelete, style }: any) => {
  const styles = useStyles();
  return (
    <div className={classNames(styles.root, { ...style })}>
      <span
        style={{ marginRight: "4px", marginBottom: 2, alignSelf: "center" }}
      >
        {label}
      </span>
      <Close
        sx={{
          fontWeight: "bold",
          fontSize: "12px",
          backgroundColor: theme.palette.common.white,
        }}
        onClick={onDelete}
        className={styles.closeIcon}
      />
    </div>
  );
};

export default CustomChip;
